import { useAuth } from '@schooly/components/authentication';
import { PRODUCTS_COPY_FROM_YEAR_ID_PARAM, PRODUCTS_YEAR_ID_PARAM } from '@schooly/constants';
import { Loading, ModalLarge } from '@schooly/style';
import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { AccessDenied } from '@schooly/style';
import { useProduct } from '../../../../context/product/WithProduct';
import { ViewState } from '../SchoolProductCreateModal/SchoolProductCreateModalContent';
import { SchoolProductModalContent } from './SchoolProductModalContent';

export interface OnEditVariantsParams {
  yearId?: string;
  copyFromYearId?: string;
}

export const SchoolProductModal: FC = () => {
  const { schoolId = '' } = useAuth();
  const navigate = useNavigate();

  const { id, product, isFetching, canView, canEdit } = useProduct();
  const close = useCallback(() => navigate('/settings/products'), [navigate]);
  const onEdit = useCallback(() => navigate(`/settings/products/${id}/edit`), [navigate, id]);
  const onEditVariants = useCallback(
    ({ yearId, copyFromYearId }: OnEditVariantsParams) => {
      const yearIdParam = yearId ? `&${PRODUCTS_YEAR_ID_PARAM}=${yearId}` : '';
      const copyFromYearIdParam = copyFromYearId
        ? `&${PRODUCTS_COPY_FROM_YEAR_ID_PARAM}=${copyFromYearId}`
        : '';

      navigate(
        `/settings/products/${id}/edit?${ViewState.Variants}${yearIdParam}${copyFromYearIdParam}`,
      );
    },
    [navigate, id],
  );

  if (isFetching) {
    return (
      <ModalLarge open onClose={close}>
        <Loading />
      </ModalLarge>
    );
  }

  if (!product || !canView) {
    return (
      <ModalLarge open onClose={close}>
        <AccessDenied />
      </ModalLarge>
    );
  }

  return (
    <SchoolProductModalContent
      schoolId={schoolId}
      product={product}
      onClose={close}
      onEdit={canEdit ? onEdit : undefined}
      onEditVariants={canEdit ? onEditVariants : undefined}
    />
  );
};
